export default "__VITE_ASSET__BYnuuuVl__"